import { merchantDashboardIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import {
  MerchantDashboardSummarySchema,
  MerchantDashboardWidgetSchema,
} from "./merchant-dashboard-fields";

export const getMerchantDashboard = {
  name: "getMerchantDashboard" as const,
  input: z.object({ dashboardId: merchantDashboardIdFormat.schema }),
  output: z.object({
    dashboard: MerchantDashboardSummarySchema,
    widgets: z.array(MerchantDashboardWidgetSchema),
  }),
};
